import { validateEmail } from '../../../utilities';

export const validatePasswordRules = (values) => {
  const errors = {};
  if (!values.password) {
    errors.password = 'Password required';
  } 
  else if (values.password.trim() === '') {
    errors.password = 'Password only contains white spaces';
  } else if (values.password.length < 6) {
    errors.password = 'Password should contain at least 6 characters';
  } else if (values.password.match('(?=.*[A-Z])') === null) {
    errors.password = 'Password should contain at least one uppercase letter';
  } else if (values.password.match('(?=.*[a-z])') === null) {
    errors.password = 'Password should contain at least one lowercase letter';
  } else if (values.password.match('(?=.*[0-9])') === null) {
    errors.password = 'Password should contain at least one number';
  } 
  return errors;
};


export const validateUserId = (values) => {
  const errors={};
  
  if (!values.sys_userid) {
    errors.sys_userid = 'User Id required';
  } else if (values.sys_userid.length > 8) {
    errors.sys_userid = 'User Id should have 8 or less characters';
  }
  return errors;
}

const validateRequiredField = (errors, value, fieldName, requiredMsg, maxLength, maxMsg) => {
  if (!value) {
    errors[fieldName] = requiredMsg;
  } else if (maxLength && value.length > maxLength) {
    errors[fieldName] = maxMsg;
  }
};

export const validate = (values) => {
  const errors = validatePasswordRules(values); 
  validateRequiredField(errors, values.sys_userid, 'sys_userid', 'User Id required', 8, 'User Id should have 8 or less characters');
  validateRequiredField(errors, values.extrn_first_name, 'extrn_first_name', 'First name required', 25, 'First name should have 25 or less characters');
  validateRequiredField(errors, values.extrn_last_name, 'extrn_last_name', 'Last name required', 25, 'Last name should have 25 or less characters');
  validateRequiredField(errors, values.extrn_addr_line1, 'extrn_addr_line1', 'Address required', 35, 'Address should have 35 or less characters');
  validateRequiredField(errors, values.extrn_postal_cd, 'extrn_postal_cd', 'Zip required', 10, 'Zip should have 10 or less characters');
  validateRequiredField(errors, values.extrn_st_prov_cd, 'extrn_st_prov_cd', 'State required', 2, 'State should have 2 or less characters');
  validateRequiredField(errors, values.extrn_city_name, 'extrn_city_name', 'City required', 35, 'City should haev 35 or less characters');
  if (!values.extrn_company_name) {
    errors.extrn_company_name = 'Firm required';
  }
  if (!values.ext_email_addr_id) {
    errors.ext_email_addr_id = 'Email required';
  } else if (!validateEmail(values.ext_email_addr_id)) {
    errors.ext_email_addr_id = 'Email is not valid';
  }
  return errors;
};
